<template>
    <div
        v-if="posts && posts.length"
        class="related-post mt-7"
    >
        <y-section-title
            type="standard"
            :title="title"
            :link="link"
            :link-text="linkText"
            :has-icon="true"
            color="primary"
        />
        <y-list-wrapper
            class="mb-14 related-post__list"
            limit="3"
            type="grid"
            :component="component"
            :col="col"
            :items="posts"
        />
    </div>
</template>

<script>
    import { YSectionTitle, YListWrapper } from '@rogues/index';

    export default {
        name: 'Related',

        components: {
            YListWrapper,
            YSectionTitle,
        },

        props: {
            /**
             * Array of related posts
             */
            posts: Array,

            /**
             * Related title
             */
            title: String,

            /**
             * Related Link
             */
            link: Object,

            /**
             * Related text of link
             */
            linkText: String,
        },

        /**
         * @inheritdoc
         */
        data() {
            return {
                component: {
                    classes     : 'mt-5',
                    name        : 'YBlogCard',
                    type        : 'Picture',
                    imageVersion: 'main',
                },
                col: {
                    xs: '12',
                    md: '4',
                },
            };
        },
    };
</script>

<style lang="scss" src="./index.scss" />
